import { FC } from 'react';

import Image from 'next/image';
import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import FishImage from './images/fish.svg';
import { AnimatedCounter } from './AnimatedCounter';

import styles from './CalcHeader.module.scss';

export const CalcHeader: FC = () => {
	const { t } = useTranslation(TranslationNamespace.Calculator);

	return (
		<header className={styles.header}>
			<div className={styles.container}>
				<div className={styles.content}>
					<div className={styles.intro}>
						<div className={styles.eyebrow}>{t('promo.eyebrow')}</div>
						<h1 className={styles.title}>{t('promo.title')}</h1>
						<p className={styles.introText}>{t('promo.description')}</p>
					</div>

					<div className={styles.summary}>
						<div className={styles.summaryLabel}>{t('promo.manual-cost')}</div>
						<div className={styles.amount}>
							<span className={styles.fishIcon} aria-hidden="true">
								<Image src={FishImage} alt="Fish icon"></Image>
							</span>
							<AnimatedCounter />
							<span className={styles.currency}>₽</span>
						</div>
						<strong className={styles.summaryDescription}>{t('promo.loss')}</strong>
						<p className={styles.summaryNote}>{t('promo.note')}</p>
					</div>
				</div>
			</div>
		</header>
	);
};
